module.exports = __webpack_public_path__ + "img/7.d39454e2.png";